import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const testimonialsFallback = [
  {
    text: "Fazia anos que eu adiava o meu exame por medo e vergonha. Com a Lumina, finalmente consegui me cuidar no conforto da minha casa, sem julgamentos.",
    author: "Maria Silva",
    avatar: "https://i.pravatar.cc/150?img=47"
  },
  {
    text: "Hoje, fiz o exame com tranquilidade pela manhã, antes de ir trabalhar. A praticidade da Lumina mudou completamente minha relação com o autocuidado.",
    author: "Ana Costa",
    avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=150&q=80"
  },
  {
    text: "A privacidade e o cuidado que a Lumina oferece me fizeram sentir segura e respeitada. Recomendo para todas as mulheres que buscam autonomia na saúde.",
    author: "Juliana Santos",
    avatar: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=150&q=80"
  }
];

const resources = {
  pt: {
    translation: {
      menu: {
        home: "Início",
        about: "Sobre",
        kit: "O Kit Lumina",
        blog: "Blog",
        contact: "Contato",
        login: "Login"
      },
      hero: {
        title: "Autocuidado sem medo, no seu tempo, com todo o cuidado que você merece.",
        description: "Transformamos um exame temido em um gesto de amor-próprio. Com total conforto, privacidade e precisão, a Lumina cuida de você.",
        action: "Como funciona"
      },
      video: {
        title: "Quando o medo vai embora, o cuidado floresce.",
        description: "Às vezes, tudo o que uma mulher precisa é de tempo, respeito e um gesto simples de coragem. O filme a seguir é para você, que já adiou o exame, mas nunca deixou de se preocupar com sua saúde. É hora de se cuidar no seu ritmo. Sem dor. Sem vergonha.",
        button: "Quero me cuidar com a Lumina"
      },
      about: {
        title: "Criada por mãos que cuidam. Pensada para vidas que florescem.",
        description: "A Lumina nasceu para eliminar as barreiras que impedem tantas mulheres de se cuidar. Nossa missão é simples: tornar o exame preventivo mais acessível, confortável e humano. Mais do que um teste, oferecemos acolhimento, conhecimento e liberdade.",
        action: "Conheça nosso produto",
        pageTitle: "Criada por mãos que cuidam. Pensada para vidas que florescem.",
        originTitle: "A origem do cuidado",
        originText: "A Lumina nasceu de uma escuta atenta. Escutamos o medo silencioso, a vergonha que paralisa, a rotina que atropela o cuidado com a saúde íntima. Por trás do número de mulheres que não fazem exames preventivos, existem histórias reais. A nossa missão é transformar essas histórias. Tornar o autocuidado algo possível, digno, acessível e... sem dor.",
        whyTitle: "Por que existimos",
        whyText: "Nós existimos por um motivo simples e urgente: ninguém deveria sofrer ou adoecer por falta de acesso, informação ou acolhimento. A Lumina é uma resposta a esse cenário. É uma inovação feita com afeto e ciência, que devolve à mulher o direito de cuidar da sua saúde no seu tempo, no seu espaço, do seu jeito.",
        driveTitle: "O que nos move",
        driveText: "Salvamos vidas com o que temos de melhor: clareza, confiança, empatia e tecnologia. Nosso kit transforma um exame temido em um gesto de amor-próprio. Nossa marca transforma um tabu em conversa. Nosso trabalho transforma medo em esperança.",
        promiseTitle: "A nossa promessa",
        promiseText: "Não vendemos apenas um produto. Entregamos autonomia, tranquilidade e dignidade. Cuidamos para que você possa cuidar de si. Do começo ao fim, você não está sozinha.",
        quote: "Porque cuidar da saúde não deveria ser um trauma. Deveria ser um gesto de amor."
      },
      kit: {
        cta: "Peça seu kit agora",
        how: "Como Funciona?",
        ctaText: "O seu corpo merece conforto. A sua rotina merece praticidade. E a sua saúde merece ser prioridade. A Lumina está aqui para simplificar a prevenção e transformar o autocuidado em um gesto de amor.",
        imgAlt: "Kit Lumina com flores decorativas",
        heroSubtitle: "Porque se cuidar nunca foi tão simples, seguro e respeitoso.",
        finalImageTitle: "A Lumina está com você, do início ao fim",
        pageVideoTitle: "Veja como usar o Kit Lumina em poucos minutos",
        pageVideoDescription: "A Lumina cuida da sua saúde sem pressa, sem dor e sem constrangimento. Assista ao vídeo para entender como realizar a coleta de forma tranquila, no seu tempo e no conforto da sua casa.",
        pageVideoButton: "Quero me cuidar com a Lumina",
        pageDescriptionTitle: "O que é o Kit Lumina?",
        pageDescriptionText: "O Kit Lumina é uma solução inovadora para o diagnóstico precoce do HPV e prevenção do câncer do colo do útero. Feito para ser usado em casa, por você mesma, sem precisar passar por um exame invasivo. Tudo com segurança clínica, privacidade e acolhimento.",
        pageFeature1: "Produtos de alta qualidade selecionados especialmente para você",
        pageFeature2: "Guias e instruções detalhadas para uso correto dos produtos",
        pageFeature3: "Suporte dedicado da nossa equipe de especialistas",
        pageFeature4: "Resultados comprovados para seu bem-estar e conforto",
        pageCTAButton: "Adquirir Kit Lumina",
        pageFinalTitle: "Está pronta para transformar sua prevenção em um gesto de amor?",
        pageFinalDescription: "Com a Lumina, o cuidado cabe na sua rotina, no seu tempo e no seu corpo. Comece hoje mesmo.",
        pageFinalButton: "Comprar agora",
        steps: {
          title1: "Prepare seu dispositivo",
          title2: "Escolha um momento só seu",
          title3: "Realize a coleta com suavidade",
          title4: "Transfira a amostra com cuidado",
          title5: "Teste rápido HPV",
          step1: "Retire o dispositivo da embalagem e remova o lacre protetor da ponta inferior. Isso garante que ele esteja pronto para a coleta. Segure com firmeza e observe o botão superior — é ele que será utilizado no momento da coleta.",
          step2: "Encontre uma posição confortável e tranquila. Você pode se deitar de costas, com os joelhos dobrados e afastados, como se estivesse relaxando. Essa posição facilita a introdução do dispositivo e garante mais conforto no processo.",
          step3: "Com o dispositivo em mãos, insira delicadamente a ponta no canal vaginal até sentir que está posicionado de forma confortável. Pressione o botão superior e mantenha pressionado por 3 segundos, depois solte. A lavagem suave será realizada automaticamente, de forma indolor.",
          step4: "Abra o tubo com solução conservante e insira apenas a ponta do dispositivo dentro dele, sem encostar nas bordas. Pressione o botão novamente para liberar o conteúdo coletado. Em seguida, feche bem o tubo, coloque-o no envelope de segurança e envie ao laboratório de sua preferência.",
          step5: "Pingue três gotas da solução na área(S) indicada da lâmina e aguarde 20 minutos. Uma linha em C indica resultado negativo, duas linhas em C e T indicam resultado positivo, e se nenhuma linha aparecer o teste é inválido e deve ser repetido. Em caso de resultado positivo, procure um médico para orientação e acompanhamento adequados."
        }
      },
      howItWorks: {
        subtitle: "Como Funciona o Kit",
        title: "Fácil, rápido e no seu tempo.",
        link: "> Saiba mais sobre o Kit",
        steps: [
          {
            icon: "/images/ico_01.webp",
            alt: "Farmácia",
            description: "Peça o seu kit online ou nas farmácias parceiras."
          },
          {
            icon: "/images/ico_02.webp",
            alt: "Coleta",
            description: "Realize a coleta no conforto de casa, com privacidade total. Sem dor. Sem constrangimento."
          },
          {
            icon: "/images/ico_03.webp",
            alt: "Laboratório",
            description: "Envie ao laboratório. Receba suporte, orientação e resultado com segurança."
          }
        ]
      },
      testimonial: {
        title: "Elas disseram sim para o autocuidado.",
        list: testimonialsFallback,
      },
      blog: {
        title: "Blog posts recentes",
        verMais: "Ver mais",
        posts: [
          {
            title: "Autoexame: por que ele veio pra ficar?",
            excerpt: "O autoexame mudou a forma como encaramos a saúde íntima. Mais autonomia, menos medo, mais cuidado e respeito ao próprio tempo. Ele veio para ficar, pra você se cuidar do seu jeito!"
          },
          {
            title: "HPV: tudo o que você precisa saber",
            excerpt: "O HPV é o vírus mais comum relacionado ao câncer do colo do útero. Ele geralmente não causa sintomas, por isso, exames preventivos periódicos são fundamentais. Prevenção é cuidado e liberdade."
          },
          {
            title: "Depoimentos de mulheres que venceram o medo",
            excerpt: "Conheça histórias reais de coragem e transformação: mulheres que venceram o receio do exame e conquistaram mais saúde e tranquilidade com o autocuidado. Inspire-se!"
          }
        ]
      },
      newsletter: {
        title: "Receba conteúdos sobre autocuidado, prevenção e saúde íntima.",
        description: "Assine e receba novidades no seu e-mail.",
        placeholder: "Digite seu e-mail",
        button: "Inscrever"
      },
      faq: {
        title: "FAQ",
        subtitle: "Ainda com dúvidas?",
        list: [
          {
            q: "É seguro fazer o exame?",
            a: "Sim, nosso kit é totalmente seguro e foi desenvolvido seguindo os mais rigorosos padrões de qualidade. Todas as amostras são processadas em laboratórios certificados e os resultados são confiáveis."
          },
          {
            q: "Qual a diferença para o papanicolau?",
            a: "Nosso teste detecta o HPV, vírus responsável por 99% dos casos de câncer do colo do útero, enquanto o papanicolau detecta alterações celulares já existentes. Nosso método é mais sensível e pode detectar problemas antes que se tornem visíveis."
          },
          {
            q: "O kit dói?",
            a: "Não, o kit foi desenvolvido para ser confortável e indolor. O dispositivo é suave e ergonômico, projetado para máxima comodidade durante a coleta."
          },
          {
            q: "Quem pode usar?",
            a: "O exame é indicado para mulheres entre 25 e 64 anos, conforme as orientações da Organização Mundial da Saúde (OMS). No entanto, toda mulher sexualmente ativa — inclusive aquelas com mais de 18 anos ou acima de 64 anos — também pode realizar o teste, priorizando o cuidado com a saúde íntima e a prevenção do câncer de colo do útero."
          },
          {
            q: "E se o resultado for positivo?",
            a: "Se o resultado for positivo, nossa equipe médica entrará em contato para orientar os próximos passos. Lembramos que um resultado positivo não significa câncer, mas sim a presença do vírus HPV, que pode ser monitorado e tratado."
          }
        ]
      },
      community: {
        title: "Juntas, somos mais fortes.",
        text: "A Lumina não é apenas uma marca, é uma rede de apoio e acolhimento. Mulheres de todas as idades e histórias se encontram aqui para compartilhar experiências, dúvidas e conquistas. Juntas, transformamos o medo em cuidado e a solidão em sororidade.",
        action: "Faça parte da nossa comunidade",
        imgAlt: "Grupo diverso de mulheres caminhando juntas"
      },
      contact: {
        title: "Fale com a Lumina",
        name: "Nome",
        email: "E-mail",
        phone: "Telefone",
        reason: "Motivo do contato",
        placeholder: "Como podemos ajudar você?",
        button: "Enviar Contato",
        sent: "Mensagem enviada! (simulação)"
      },
      footer: {
        fale: "Fale com a gente",
        desc: "Estamos aqui para tirar dúvidas, ouvir sugestões e apoiar você em cada etapa do seu autocuidado.",
        email: "E-mail:",
        tel: "Telefone:",
        adr: "Endereço:",
        sigalumina: "Siga a Lumina",
        copyright: "© 2024 Lumina. Todos os direitos reservados."
      }
    }
  },

  en: {
    translation: {
      menu: {
        home: "Home",
        about: "About",
        kit: "The Lumina Kit",
        blog: "Blog",
        contact: "Contact",
        login: "Login"
      },
      hero: {
        title: "Self-care without fear, at your time, with all the care you deserve.",
        description: "We transform a dreaded exam into an act of self-care. With total comfort, privacy and precision, Lumina takes care of you.",
        action: "How it works"
      },
      video: {
        title: "When fear goes away, care flourishes.",
        description: "Sometimes all a woman needs is time, respect and a simple act of courage. This short film is for you, who postponed the exam, but never stopped caring for your health. It's time to care at your pace. No pain. No shame.",
        button: "I want to take care of myself with Lumina"
      },
      about: {
        title: "Created by caring hands. Designed for lives that bloom.",
        description: "Lumina was born to eliminate the barriers that prevent so many women from taking care of themselves. Our mission is simple: to make the preventive exam more accessible, comfortable and humane. More than a test, we offer support, knowledge and freedom.",
        action: "See our product",
        pageTitle: "Created by caring hands. Designed for lives that bloom.",
        originTitle: "The origin of care",
        originText: "Lumina was born from attentive listening. We heard the silent fear, the shame that paralyzes, the routine that tramples intimate health care. Behind the number of women who don't get preventive exams, there are real stories. Our mission is to transform those stories. Make self-care something possible, dignified, accessible and... painless.",
        whyTitle: "Why we exist",
        whyText: "We exist for a simple and urgent reason: no one should suffer or become ill from lack of access, information or support. Lumina is a response to this scenario. It's an innovation made with affection and science that returns to women the right to care for their health in their time, their space, their way.",
        driveTitle: "What drives us",
        driveText: "We save lives with what we have best: clarity, confidence, empathy and technology. Our kit transforms a dreaded exam into an act of self-love. Our brand transforms a taboo into conversation. Our work transforms fear into hope.",
        promiseTitle: "Our promise",
        promiseText: "We don't just sell a product. We deliver autonomy, peace of mind and dignity. We care so you can take care of yourself. From start to finish, you are not alone.",
        quote: "Because taking care of health shouldn't be a trauma. It should be an act of love."
      },
      kit: {
        cta: "Order your kit now",
        how: "How does it work?",
        ctaText: "Your body deserves comfort. Your routine deserves practicality. And your health deserves to be a priority. Lumina is here to simplify prevention and transform self-care into a gesture of love.",
        imgAlt: "Lumina Kit with decorative flowers",
        heroSubtitle: "Because caring for yourself has never been so simple, safe, and respectful.",
        finalImageTitle: "Lumina is with you, from start to finish",
        pageVideoTitle: "See how to use the Lumina Kit in minutes",
        pageVideoDescription: "Lumina takes care of your health without haste, pain or embarrassment. Watch the video to understand how to perform collection calmly, at your pace and in the comfort of your home.",
        pageVideoButton: "I want to take care of myself with Lumina",
        pageDescriptionTitle: "What is the Lumina Kit?",
        pageDescriptionText: "The Lumina Kit is an innovative solution for early HPV diagnosis and cervical cancer prevention. Designed to be used at home, by yourself, without needing an invasive exam. All with clinical safety, privacy and support.",
        pageFeature1: "High quality products specially selected for you",
        pageFeature2: "Guides and detailed instructions for proper use of products",
        pageFeature3: "Dedicated support from our team of experts",
        pageFeature4: "Proven results for your well-being and comfort",
        pageCTAButton: "Get Lumina Kit",
        pageFinalTitle: "Are you ready to transform your prevention into an act of love?",
        pageFinalDescription: "With Lumina, care fits into your routine, your time and your body. Start today.",
        pageFinalButton: "Buy now",
        steps: {
          title1: "Prepare your device",
          title2: "Choose a moment for yourself",
          title3: "Perform collection gently",
          title4: "Transfer the sample carefully",
          title5: "HPV rapid test",
          step1: "Remove the device from the packaging and take off the protective seal from the lower tip. This ensures it's ready for collection. Hold it firmly and note the top button — that's the one you'll use during collection.",
          step2: "Find a comfortable, calm position. You can lie on your back with knees bent and apart, as if relaxing. This position makes insertion easier and more comfortable.",
          step3: "With the device in hand, gently insert the tip into the vaginal canal until it feels comfortably positioned. Press the top button and hold for 3 seconds, then release. The gentle rinse will be performed automatically and painlessly.",
          step4: "Open the tube with the preservative solution and insert only the tip of the device into it, without touching the edges. Press the button again to release the collected content. Then, close the tube tightly, place it in the safety envelope, and send it to the laboratory of your choice.",
          step5: "Place three drops of the solution on the indicated area(s) of the slide and wait 20 minutes. One line at C indicates a negative result; two lines at C and T indicate a positive result; if no line appears, the test is invalid and must be repeated. If the result is positive, seek medical advice for proper guidance and follow-up."
        }
      },
      howItWorks: {
        subtitle: "How the Kit Works",
        title: "Easy,\u00A0fast.\nand\u00A0on\u00A0your.\ntime.",
        link: "> Learn more about the Kit",
        steps: [
          {
            icon: "/images/ico_01.webp",
            alt: "Pharmacy",
            description: "Order your kit online or at partner pharmacies."
          },
          {
            icon: "/images/ico_02.webp",
            alt: "Collection",
            description: "Perform the collection in the comfort of home, with total privacy. No pain. No embarrassment."
          },
          {
            icon: "/images/ico_03.webp",
            alt: "Laboratory",
            description: "Send to the laboratory. Receive support, guidance and results with security."
          }
        ]
      },
      testimonial: {
        title: "They said yes to self-care.",
        list: [
          {
            text: "For years I postponed my exam out of fear and embarrassment. With Lumina, I finally managed to care for myself in the comfort of my home, free of judgment.",
            author: "Maria Silva",
            avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b786?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=150&q=80"
          },
          {
            text: "Today, I did the exam easily in the morning before work. Lumina's practicality completely changed my relationship with self-care.",
            author: "Ana Costa",
            avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=150&q=80"
          },
          {
            text: "The privacy and care Lumina offers made me feel safe and respected. I recommend it to every woman looking for autonomy over her health.",
            author: "Juliana Santos",
            avatar: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=150&q=80"
          }
        ]
      },
      blog: {
        title: "Recent Blog Posts",
        verMais: "See more",
        posts: [
          {
            title: "Self-exam: why it is here to stay?",
            excerpt: "Self-exam has changed how we see intimate health. More autonomy, less fear, more care and respect for your own timing. It's here to stay, so you can care for yourself your way!"
          },
          {
            title: "HPV: Everything You Need to Know",
            excerpt: "HPV is the most common virus related to cervical cancer. Most of the time, it has no symptoms, so preventive exams are fundamental. Prevention is care and freedom."
          },
          {
            title: "Testimonials from women who overcame fear",
            excerpt: "Read real stories of courage and transformation: women who overcame fear of the exam and achieved more health and tranquility with self-care. Be inspired!"
          }
        ]
      },
      newsletter: {
        title: "Get content on self-care, prevention and intimate health.",
        description: "Subscribe and receive updates to your email.",
        placeholder: "Enter your email",
        button: "Subscribe"
      },
      faq: {
        title: "FAQ",
        subtitle: "Still got questions?",
        list: [
          {
            q: "Is the test safe?",
            a: "Yes, our kit is totally safe and developed under the strictest quality standards. All samples are processed in certified labs and results are reliable."
          },
          {
            q: "What is the difference compared to pap smear?",
            a: "Our test detects HPV, responsible for 99% of cervical cancer cases, while the pap smear detects already existing cell changes. Our method is more sensitive and can detect issues earlier."
          },
          {
            q: "Is the kit painful?",
            a: "No, the kit was designed to be comfortable and painless. The device is smooth and ergonomic for maximum comfort during collection."
          },
          {
            q: "Who can use it?",
            a: "The test is recommended for women between 25 and 64 years old, according to World Health Organization (WHO) guidelines. However, any sexually active woman — including those over 18 or above 64 — can also take the test, prioritizing intimate health care and the prevention of cervical cancer."
          },
          {
            q: "What if the result is positive?",
            a: "If it's positive, our medical team will contact you to guide next steps. A positive result is not cancer, but presence of HPV virus, which can be monitored and treated."
          }
        ]
      },
      community: {
        title: "Together, we are stronger.",
        text: "Lumina is not just a brand, it's a network of support and welcome. Women of all ages and stories come together here to share experiences, questions and achievements. Together, we transform fear into care and loneliness into sorority.",
        action: "Join our community",
        imgAlt: "Diverse group of women walking together"
      },
      contact: {
        title: "Contact Lumina",
        name: "Name",
        email: "Email",
        phone: "Phone",
        reason: "Contact reason",
        placeholder: "How can we help you?",
        button: "Send Contact",
        sent: "Message sent! (simulation)"
      },
      footer: {
        fale: "Contact us",
        desc: "We're here to answer questions, listen to suggestions and support you on every step.",
        email: "Email:",
        tel: "Phone:",
        adr: "Address:",
        sigalumina: "Follow Lumina",
        copyright: "© 2024 Lumina. All rights reserved."
      }
    }
  },
  es: {
    translation: {
      menu: {
        home: "Inicio",
        about: "Sobre",
        kit: "El kit Lumina",
        blog: "Blog",
        contact: "Contacto",
        login: "Iniciar sesión"
      },
      hero: {
        title: "Autocuidado sin miedo, a tu ritmo, con todo el cuidado que te mereces.",
        description: "Transformamos un examen temido en un gesto de amor propio. Con total comodidad, privacidad y precisión, Lumina te cuida.",
        action: "Cómo funciona"
      },
      video: {
        title: "Cuando el miedo se va, florece el cuidado.",
        description: "A veces, todo lo que una mujer necesita es tiempo, respeto y un simple acto de coraje. La película a continuación es para ti, que ya has pospuesto el examen, pero nunca dejaste de cuidar tu salud. Es hora de cuidarte a tu ritmo. Sin dolor. Sin vergüenza.",
        button: "Quiero cuidarme con Lumina"
      },
      about: {
        title: "Creada por manos que cuidan. Pensada para vidas que florecen.",
        description: "Lumina nació para eliminar las barreras que impiden que tantas mujeres se cuiden. Nuestra misión es simple: hacer que el examen preventivo sea más accesible, cómodo y humano. Más que una prueba, ofrecemos acogida, conocimiento y libertad.",
        action: "Conoce nuestro producto",
        pageTitle: "Creada por manos que cuidan. Pensada para vidas que florecen.",
        originTitle: "El origen del cuidado",
        originText: "Lumina nació de una escucha atenta. Escuchamos el miedo silencioso, la vergüenza que paraliza, la rutina que atropella el cuidado de la salud íntima. Detrás del número de mujeres que no se hacen exámenes preventivos, hay historias reales. Nuestra misión es transformar esas historias. Hacer del autocuidado algo posible, digno, accesible y... sin dolor.",
        whyTitle: "Por qué existimos",
        whyText: "Existimos por una razón simple y urgente: nadie debería sufrir o enfermar por falta de acceso, información o acogida. Lumina es una respuesta a este escenario. Es una innovación hecha con afecto y ciencia, que devuelve a la mujer el derecho de cuidar su salud a su tiempo, en su espacio, a su manera.",
        driveTitle: "Lo que nos impulsa",
        driveText: "Salvamos vidas con lo mejor que tenemos: claridad, confianza, empatía y tecnología. Nuestro kit transforma un examen temido en un gesto de amor propio. Nuestra marca transforma un tabú en conversación. Nuestro trabajo transforma el miedo en esperanza.",
        promiseTitle: "Nuestra promesa",
        promiseText: "No solo vendemos un producto. Entregamos autonomía, tranquilidad y dignidad. Cuidamos para que puedas cuidarte. Del principio al fin, no estás sola.",
        quote: "Porque cuidar la salud no debería ser un trauma. Debería ser un gesto de amor."
      },
      kit: {
        cta: "Pide tu kit ahora",
        how: "¿Cómo funciona?",
        ctaText: "Tu cuerpo merece comodidad. Tu rutina merece practicidad. Y tu salud merece ser prioridad. Lumina está aquí para simplificar la prevención y transformar el autocuidado en un gesto de amor.",
        imgAlt: "Kit Lumina con flores decorativas",
        heroSubtitle: "Porque cuidarte nunca fue tan simple, seguro y respetuoso.",
        finalImageTitle: "Lumina está contigo, de principio a fin",
        pageVideoTitle: "Ve cómo usar el Kit Lumina en pocos minutos",
        pageVideoDescription: "Lumina cuida tu salud sin prisa, sin dolor y sin vergüenza. Mira el video para entender cómo realizar la recolección con tranquilidad, a tu ritmo y en la comodidad de tu casa.",
        pageVideoButton: "Quiero cuidarme con Lumina",
        pageDescriptionTitle: "¿Qué es el Kit Lumina?",
        pageDescriptionText: "El Kit Lumina es una solución innovadora para el diagnóstico temprano del VPH y la prevención del cáncer de cuello uterino. Diseñado para ser usado en casa, por ti misma, sin necesidad de pasar por un examen invasivo. Todo con seguridad clínica, privacidad y acogida.",
        pageFeature1: "Productos de alta calidad especialmente seleccionados para ti",
        pageFeature2: "Guías e instrucciones detalladas para el uso correcto de los productos",
        pageFeature3: "Soporte dedicado de nuestro equipo de especialistas",
        pageFeature4: "Resultados comprobados para tu bienestar y comodidad",
        pageCTAButton: "Adquirir Kit Lumina",
        pageFinalTitle: "¿Estás lista para transformar tu prevención en un gesto de amor?",
        pageFinalDescription: "Con Lumina, el cuidado cabe en tu rutina, en tu tiempo y en tu cuerpo. Comienza hoy mismo.",
        pageFinalButton: "Comprar ahora",
        steps: {
          title1: "Prepara tu dispositivo",
          title2: "Elige un momento para ti",
          title3: "Realiza la recolección con suavidad",
          title4: "Transfiere la muestra con cuidado",
          title5: "Prueba rápida de VPH",
          step1: "Retira el dispositivo del empaque y quita el sello protector de la punta inferior. Esto garantiza que esté listo para la recolección. Sujétalo firmemente y observa el botón superior: será el utilizado en el momento de la recolección.",
          step2: "Busca una posición cómoda y tranquila. Puedes acostarte boca arriba, con las rodillas dobladas y separadas, como si estuvieras relajando. Esta posición facilita la introducción del dispositivo y brinda más comodidad.",
          step3: "Con el dispositivo en mano, inserta suavemente la punta en el canal vaginal hasta sentir que está colocado de forma cómoda. Presiona el botón superior y mantenlo presionado durante 3 segundos, luego suelta. El lavado suave se realizará automáticamente y sin dolor.",
          step4: "Abre el tubo con solución conservante e introduce solo la punta del dispositivo dentro de él, sin tocar los bordes. Presiona el botón nuevamente para liberar el contenido recolectado. Luego, cierra bien el tubo, colócalo en el sobre de seguridad y envíalo al laboratorio de tu preferencia.",
          step5: "Coloca tres gotas de la solución en la(s) zona(s) indicada(s) de la lámina y espera 20 minutos. Una línea en C indica resultado negativo; dos líneas en C y T indican resultado positivo; si no aparece ninguna línea, la prueba es inválida y debe repetirse. En caso de resultado positivo, busca orientación médica para el seguimiento adecuado."
        }
      },
      howItWorks: {
        subtitle: "Cómo Funciona el Kit",
        title: "Fácil,\u00A0rápido.\ny\u00A0a\u00A0tu.\nritmo.",
        link: "> Saber más sobre el Kit",
        steps: [
          {
            icon: "/images/ico_01.webp",
            alt: "Farmacia",
            description: "Pide tu kit online o en las farmacias asociadas."
          },
          {
            icon: "/images/ico_02.webp",
            alt: "Recolección",
            description: "Realiza la recolección en la comodidad de tu casa, con total privacidad. Sin dolor. Sin vergüenza."
          },
          {
            icon: "/images/ico_03.webp",
            alt: "Laboratorio",
            description: "Envía al laboratorio. Recibe apoyo, orientación y resultados con seguridad."
          }
        ]
      },
      testimonial: {
        title: "Ellas dijeron sí al autocuidado.",
        list: [
          {
            text: "Durante años pospuse mi examen por miedo y vergüenza. Con Lumina, finalmente logré cuidarme en la comodidad de mi casa, sin juicios.",
            author: "Maria Silva",
            avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b786?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=150&q=80"
          },
          {
            text: "Hoy me hice el examen tranquila por la mañana, antes de ir a trabajar. La practicidad de Lumina cambió por completo mi relación con el autocuidado.",
            author: "Ana Costa",
            avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=150&q=80"
          },
          {
            text: "La privacidad y el cuidado que ofrece Lumina me hicieron sentir segura y respetada. Lo recomiendo a todas las mujeres que buscan autonomía en su salud.",
            author: "Juliana Santos",
            avatar: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=150&q=80"
          }
        ]
      },
      blog: {
        title: "Publicaciones recientes",
        verMais: "Ver más",
        posts: [
          {
            title: "Autoexamen: por qué vino para quedarse?",
            excerpt: "El autoexamen cambió cómo vemos la salud íntima. Más autonomía, menos miedo, más cuidado y respeto por tu ritmo. ¡Vino para quedarse, para que te cuides a tu manera!"
          },
          {
            title: "VPH: todo lo que debes saber",
            excerpt: "El VPH es el virus más común relacionado con el cáncer de cuello uterino. Generalmente no causa síntomas, por lo que los exámenes preventivos periódicos son fundamentales. Prevenir es cuidar y tener libertad."
          },
          {
            title: "Testimonios de mujeres que vencieron el miedo",
            excerpt: "Conoce historias reales de coraje y transformación: mujeres que vencieron el miedo al examen y lograron más salud y tranquilidad con el autocuidado. ¡Inspírate!"
          }
        ]
      },
      newsletter: {
        title: "Recibe contenidos sobre autocuidado, prevención y salud íntima.",
        description: "Suscríbete y recibe novedades en tu e-mail.",
        placeholder: "Ingresa tu e-mail",
        button: "Suscríbete"
      },
      faq: {
        title: "Preguntas frecuentes",
        subtitle: "¿Aún tienes dudas?",
        list: [
          {
            q: "¿Es seguro hacer el examen?",
            a: "Sí, nuestro kit es totalmente seguro y fue desarrollado bajo los más estrictos estándares de calidad. Todas las muestras son procesadas en laboratorios certificados y los resultados son confiables."
          },
          {
            q: "¿Cuál es la diferencia con el papanicolau?",
            a: "Nuestro test detecta el VPH, virus responsable del 99% de los casos de cáncer de cuello uterino, mientras que el papanicolau detecta alteraciones celulares ya existentes. Nuestro método es más sensible y puede detectar problemas antes."
          },
          {
            q: "¿Duele el kit?",
            a: "No, el kit fue desarrollado para ser cómodo e indoloro. El dispositivo es suave y ergonómico, diseñado para la máxima comodidad durante la recolección."
          },
          {
            q: "¿Quién puede usarlo?",
            a: "El examen está indicado para mujeres entre 25 y 64 años, según las orientaciones de la Organización Mundial de la Salud (OMS). Sin embargo, toda mujer sexualmente activa —incluidas aquellas mayores de 18 años o por encima de 64 años— también puede realizar la prueba, priorizando el cuidado de la salud íntima y la prevención del cáncer de cuello uterino."
          },
          {
            q: "¿Y si el resultado es positivo?",
            a: "Si el resultado es positivo, nuestro equipo médico se pondrá en contacto para orientar los próximos pasos. Un resultado positivo no significa cáncer, sino la presencia del virus VPH, que puede ser monitoreado y tratado."
          }
        ]
      },
      contact: {
        title: "Hable con Lumina",
        name: "Nombre",
        email: "E-mail",
        phone: "Teléfono",
        reason: "Motivo del contacto",
        placeholder: "¿Cómo podemos ayudarte?",
        button: "Enviar contacto",
        sent: "¡Mensaje enviado! (simulación)"
      },
      community: {
        title: "Juntas, somos más fuertes.",
        text: "Lumina no es solo una marca, es una red de apoyo y acogida. Mujeres de todas las edades e historias se encuentran aquí para compartir experiencias, dudas y logros. Juntas, transformamos el miedo en cuidado y la soledad en sororidad.",
        action: "Únete a nuestra comunidad",
        imgAlt: "Grupo diverso de mujeres caminando juntas"
      },
      footer: {
        fale: "Hable con nosotros",
        desc: "Estamos aquí para responder preguntas, escuchar sugerencias y apoyarla en cada etapa.",
        email: "E-mail:",
        tel: "Teléfono:",
        adr: "Dirección:",
        sigalumina: "Sigue a Lumina",
        copyright: "© 2024 Lumina. Todos los derechos reservados."
      }
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
